import styled from 'styled-components';

export const ContainerSelect = styled.div`
  width: ${(props) => `${props.Width}`};
  margin: ${(props) => `${props.Margin}`};
  label {
    font-size: 15px;
    font-weight: 600;
  }
`;

export const Select = styled.select`
  border: 0px;
  border-bottom: 2px solid var(--primary-color);
  font-size: 18px;
  margin: 0px !important;
  width: 100%;
  height: 37px;
  border-radius: 5px;
`;
